import View from './View';
import schema from './schema';
import icon from '@plone/volto/icons/divide-horizontal.svg';

const DividerBlock = {
  id: 'dividers',
  title: 'Divider',
  view: View,
  icon: icon,
  group: 'castle',
  restricted: false,
  mostUsed: false,
  sidebarTab: 1,
  blockSchema: schema,
};

export default DividerBlock;